// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--ModalLayout-Layouts-components__3gV9o","overlay":"overlay--ModalLayout-Layouts-components__1pMoV","popup":"popup--ModalLayout-Layouts-components__Hg0zH"};